import {
  CLEAR_STRIPE_STORE,
  SET_ACTIVE_STRIPE_PRODUCT_ID,
  SET_ACTIVE_STRIPE_SUBSCRIPTION,
  SET_STRIPE_PAID_LINK,
  SET_STRIPE_TRIAL_DAYS_LEFT,
  SET_SUBSCRIPTION_IS_ENDED,
} from 'store/actions/actionTypes';
import { IPaymentStore } from 'types/payment/Payment';
import { Action } from 'types/redux';

const initialState: IPaymentStore = {
  stripe: {
    activeProductID: null,
    activePriceID: null,
    subscriptionID: null,
  },
  activeSubscription: null,
  subscription_is_ended: false,
  stripe_paid_link: null,
  trial_days_left: null,
};

// eslint-disable-next-line default-param-last
const payment = (state: IPaymentStore = initialState, action: Action) => {
  switch (action.type) {
    case SET_ACTIVE_STRIPE_PRODUCT_ID:
      return {
        ...state,
        stripe: action.payload,
      };
    case SET_ACTIVE_STRIPE_SUBSCRIPTION:
      return {
        ...state,
        activeSubscription: action.payload,
      };
    case SET_SUBSCRIPTION_IS_ENDED:
      return {
        ...state,
        subscription_is_ended: action.payload,
      };
    case SET_STRIPE_PAID_LINK:
      return {
        ...state,
        stripe_paid_link: action.payload,
      };
    case SET_STRIPE_TRIAL_DAYS_LEFT:
      return {
        ...state,
        trial_days_left: action.payload,
      };
    case CLEAR_STRIPE_STORE:
      return initialState;
    default:
      return state;
  }
};

export default payment;